/* Copyright (c) 2022, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

/*
Enums here should have Tracer keyword sepcified in it to identify main task
*/
export enum LogTracerNames {
    EvidencePanel = 'EvidencePanelTracer',
    Search = 'SearchTracer',
    SeeMore = 'SeeMoreTracer',
    UserInfo = 'UserDetails',
    Login = 'LoginTracer',
    Settings = 'SettingsTracer',
    Feedback = 'FeedbackTracer'
}

export enum LogTracerActions {
    open = 'Opened',
    close = 'Closed'
}

export enum LogTracerSubLevels {
    UserGesture = 'UserGesture',
    Endpoint = 'EndPoint',
    Errormessage = 'ErrorMessage',
    PushNotification = 'PushNotification',
    UserDetails = 'UserDetails'
}
